import { ComponentConfigMap } from "./types";

export interface ComponentDefinition {
  // Property name on both the UMD global and the component's own module exports
  componentName: string;
  // window global the UMD bundle for this category attaches itself to
  umdGlobal: string;
  // Name of the bundle that ships this component
  category: string;
}

// Components definitions are added here, make sure to add a corresponding
// entry in ComponentConfigMap (types/index.ts) too.
export const COMPONENT_DEFINITIONS: Record<
  keyof ComponentConfigMap,
  ComponentDefinition
> = {
  "billing-request": {
    componentName: "BillingRequest",
    umdGlobal: "GcComponentsCheckout",
    category: "checkout",
  },
  "remember-me-signup": {
    componentName: "RememberMeSignup",
    umdGlobal: "GcComponentsCheckout",
    category: "checkout",
  },
  "remember-me-return-flow": {
    componentName: "RememberMeReturnFlow",
    umdGlobal: "GcComponentsCheckout",
    category: "checkout",
  },
};
